import {Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy} from '@angular/core';
import {
    GridComponent,
    RowClassArgs,
    PageChangeEvent,
    GridDataResult,
    SortSettings
} from '@progress/kendo-angular-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { SharedPanelService } from '../shared-panel/shared-panel.service';
import { AuthService } from '../../../core/services/auth.service';
import { GestionService } from '../../modulos/taller/componentes/gestion-or/gestion.service';
import {GlobalsService} from '../../../core/services/globals.service';
import {Subject} from 'rxjs/internal/Subject';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'dms-generic-table',
    templateUrl: './generic-table.component.html',
    styleUrls: ['./generic-table.component.scss']
})
export class GenericTableComponent implements OnInit, OnDestroy {

    private destroy: Subject<any> = new Subject();

    @ViewChild(GridComponent, { static: false })
    public grid: GridComponent;
    public buttonCount = 2; // 10
    public info = true;
    public type = 'numeric';
    public pageSizes = this._globalsService.getPageSizeList();
    public previousNext = true;
    @Input() selectable?: boolean;
    @Input() pageNumber?: number;
    @Input() skip?: number;
    @Input() pageSize?: number;
    public pageable: any;
    @Input() dataTable: any[];
    @Input() isLoading: Boolean;
    @Output() pChange = new EventEmitter<any>();
    @Output() selectAccount = new EventEmitter<any>();
    @Input() hasPage?: Boolean;
    @Input() sort: SortDescriptor[];
    public allowUnsort = true;
    @Input() sortable: SortSettings = { allowUnsort: this.allowUnsort,  mode: 'single' };
    @Output() tab = new EventEmitter<number>();
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onTabselect = new EventEmitter<any>();
    @Input() resizable?= true;
    @Output() onIconSelect = new EventEmitter<any>();

    public gridView: GridDataResult;

    public colorModulo: string;
    activarLamparita: boolean;
    classColor = '';
    public moduloActivo: number;
    public selected: number;

    constructor(
        private _gestionService: GestionService,
        private _authService: AuthService,
        public _sharedPanelService: SharedPanelService,
        public _globalsService: GlobalsService,
    ) {
        this.activarLamparita = false;
    }

    ngOnInit() {
        if (this.selectable === undefined) {
            this.selectable = true;
        }

        this.selected = 0;
        this.moduloActivo = this._authService.getModuloActivo() + 1;
        this.classColor = 'backgroundModulo' + this.moduloActivo;
        if (this.hasPage || this.hasPage === undefined) {
            this.pageable = {
                'buttonCount': this.buttonCount,
                'info': this.info,
                'type': this.type,
                'pageSizes': this.pageSizes,
                'previousNext': this.previousNext
            };
        } else {
            this.pageable = false;
        }
        this._sharedPanelService.observerisSwitchedOn().pipe(takeUntil(this.destroy)).subscribe(val => {
            this.activarLamparita = val;
        });
        this._gestionService.observerPestana().pipe(takeUntil(this.destroy)).subscribe(val => {
            this.selected = val;
        });
        if (this.pageSize == null) {
            this.pageSize = this._globalsService.getDefaultPageSize();
        }
    }

    ngOnDestroy() {
        this.destroy.next();
        this.destroy.complete();
    }

    //Esta función es la que se llama para concatenar 2 campos de base de datos cualesquiera (pensado para la numeración de las facturas, OR's, etc)
    labelFunction(dataItem, camposConcatenados: String): String {
        var campo1: String = '';
        var campo2: String = '';

        campo1 = dataItem[(camposConcatenados.substring(0, (camposConcatenados.indexOf(';'))))];
        campo2 = dataItem[(camposConcatenados.substring((camposConcatenados.indexOf(';') + 1), camposConcatenados.length))];

        return (campo1 + '-' + campo2);
    }

    //Esta función es la que emite el evento cuando seleccionamos una fila
    selectRow(event) {
        this.selectAccount.emit(event);

    }
    rowCallback = (context: RowClassArgs) => {
        return this.classColor;
    }

    public sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
        this.loadProducts();
    }

    private loadProducts(): void {
        this.dataTable[this.selected].gridView = {
            data: orderBy(this.dataTable[this.selected].gridView.data, this.sort),
            total: this.dataTable[this.selected].gridView.data.length
        };
    }
    pageChange(event: PageChangeEvent): void {
        //     this.skip = event.skip;
        //     this.pageSize = event.take;
        //     this.pageNumber = 1;
        // if (event) {
        //   this.pageNumber = event.skip / this.pageSize + 1;
        // } else {
        //   this.skip = 0;
        // }
        // this.pagesInfo.emit(this.paginationServer(this.pageNumber, this.pageSize));
        this.pChange.emit(event);
    }

    private pageData(): void {
        this.dataTable[0].gridView.data = this.dataTable[0].gridView.data.slice(this.skip, this.skip + this.pageSize);
    }
    onTabSelect(event) {
        this.tab.emit(event['index']);
        this.selected = event.index;
        this.onTabselect.emit(event);
    }

    paginationServer(number, size) {
        return {
            'Number': number,
            'Size': size,
            'TotalElements': null,
            'TotalPages': null
        }
    }

    redireccionarOR(item: any) {
        this.onIconSelect.emit(item);

    }

}
